module.exports = __webpack_public_path__ + "img/Dredd_Thumb.bc4af740.jpg";